// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerodrome-operations-general-duties.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerodrome-operations-general-duties/aerodrome-operations-general-duties.js';
import g1 from '../lessons/air-law/aerodrome-operations-general-duties/traffic-circuit.js';

mount([g0, g1]);
